import { Root } from '@radix-ui/react-context-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface ContextMenuProps extends ComponentPropsWithoutRef<
  typeof Root
> {
  dir?: 'ltr' | 'rtl'
  onOpenChange?: (open: boolean) => void
  modal?: boolean
  children: ReactNode
}

export const ContextMenu = Root
